import {createModel} from "@rematch/core";

import {RootModel} from "./index";
import * as api from "../apis/app";
import * as minio from "../utils/minio";


export interface SiteConfigs {
    title: string,
    icp: string,
    copyright: string,
    favicon: string,
    logo: string,
    background: string,
}

interface AppState {
    siteConfigs: SiteConfigs | undefined
}

const initState: AppState = {
    siteConfigs: undefined,
}

export const app = createModel<RootModel>()({
        state: initState,
        reducers: {
            setSiteConfigs: (state: AppState, payload: SiteConfigs) => ({...state, siteConfigs: payload}),
        },
        effects: (dispatch) => ({
            async loadSiteConfigs() {
                const response = await api.getSiteConfigurations()
                dispatch.app.setSiteConfigs({
                    title: response.data.data['site-title'],
                    icp: response.data.data['site-icp'],
                    copyright: response.data.data['site-copyright'],
                    favicon: minio.getUrl(response.data.data['site-favicon']),
                    logo: minio.getUrl(response.data.data['site-logo']),
                    background: minio.getUrl(response.data.data['site-admin-background']),
                })
            }
        })
    }
)
